import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type AnchorLinkProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const AnchorLink: FunctionComponent<AnchorLinkProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'anchor-link'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            viewBox="0 0 250 250"
        >
            <path d="M140.9 165.5c-15.1 0-29.3-5.9-39.9-16.5-2.7-2.7-5.1-5.7-7.2-8.9-1.4-2.1-.8-4.9 1.3-6.2 2.1-1.4 4.9-.8 6.2 1.3 1.8 2.7 3.8 5.2 6.1 7.5 9 9 20.9 13.9 33.6 13.9s24.6-4.9 33.6-13.9l51.5-51.5c9-9 13.9-20.9 13.9-33.6S234.9 33 225.9 24c-18.5-18.5-48.6-18.5-67.1 0l-47 47c-1.8 1.8-4.6 1.8-6.4 0s-1.8-4.6 0-6.4l47-47c22-22 57.8-22 79.9 0 10.7 10.7 16.5 24.8 16.5 39.9s-5.9 29.3-16.5 39.9L180.8 149c-10.6 10.7-24.8 16.5-39.9 16.5z" />
            <path d="M57.6 248.8c-15.1 0-29.3-5.9-39.9-16.5-22-22-22-57.8 0-79.9L69.1 101c10.7-10.7 24.9-16.6 40-16.6s29.3 5.9 39.9 16.5c2.4 2.4 4.6 5.1 6.6 7.8 1.4 2 .9 4.8-1.1 6.3-2 1.4-4.8.9-6.3-1.1-1.6-2.3-3.5-4.6-5.5-6.6-9-9-20.9-13.9-33.6-13.9s-24.6 4.9-33.6 13.9L24 158.8c-18.5 18.5-18.5 48.6 0 67.1 9 9 20.9 13.9 33.6 13.9s24.6-4.9 33.6-13.9l47.9-47.9c1.8-1.8 4.6-1.8 6.4 0s1.8 4.6 0 6.4l-47.9 47.9c-10.7 10.7-24.9 16.5-40 16.5z" />
        </svg>
    );
};

export default AnchorLink;
